var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuropea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "171px",
    height: "18px",
    viewBox: "0 0 171 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LA EUROPEA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_Comprar",
    transform: "translate(-324.000000, -354.000000)",
    fill: "#253157",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(292.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LA-EUROPEA",
    transform: "translate(32.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13 18 13 14.35 4.31620553 14.35 4.31620553 1 0 1 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18 L18.2618384,18 L19.4401114,14.875 L26.5849582,14.875 L27.7381616,18 L32,18 L25.5320334,1 L20.5933148,1 L14,18 Z M23.0752089,5.15 L25.5320334,11.8 L20.4930362,11.8 L23.0752089,5.15 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "55 18 55 14.35 45.1025641 14.35 45.1025641 11.1 53.1282051 11.1 53.1282051 7.575 45.1025641 7.575 45.1025641 4.65 55 4.65 55 1 41 1 41 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2464455,0 L58,0 L58,10.1070912 C58,14.6917511 60.8309637,18 65.9620853,18 C71.1690363,18 74,14.3531114 74,10.1070912 L74,0 L69.7535545,0 L69.7535545,9.82054993 C69.7535545,12.3212735 68.4897314,13.9363242 65.9620853,13.9363242 C63.5102686,13.9363242 62.2464455,12.3733719 62.2464455,9.82054993 L62.2464455,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,17.7391304 L82.2123894,17.7391304 L82.2123894,11.3478261 L83.1150442,11.3478261 C85.3466077,12.9391304 88.2050147,18 92.1165192,18 C93.2699115,18 94.2979351,17.6869565 95,17.3217391 L94.5988201,13.8782609 C94.0722714,14.1130435 93.3451327,14.2173913 92.7935103,14.2173913 C91.2138643,14.2173913 89.7094395,12.6521739 88.179941,11.1913043 C90.7625369,10.6434783 92.6430678,8.63478261 92.6430678,5.84347826 C92.6430678,1.69565217 89.4085546,0 86.0988201,0 L78,0 L78,17.7391304 Z M86.0235988,3.80869565 C87.4026549,3.80869565 88.280236,4.64347826 88.280236,6 C88.280236,7.30434783 87.4026549,8.19130435 86.0235988,8.19130435 L82.2123894,8.19130435 L82.2123894,3.80869565 L86.0235988,3.80869565 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,9.02571429 C97,14.1428571 100.857143,18 105.974286,18 C111.142857,18 115,14.1428571 115,9.02571429 C115,3.85714286 111.142857,0 105.974286,0 C100.857143,0 97,3.85714286 97,9.02571429 Z M101.242857,9.02571429 C101.242857,6.19714286 103.248571,4.08857143 106,4.08857143 C108.828571,4.08857143 110.757143,6.19714286 110.757143,9.02571429 C110.757143,11.8028571 108.828571,13.9371429 106,13.9371429 C103.248571,13.9371429 101.242857,11.8028571 101.242857,9.02571429 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,18 L123.278438,18 L123.278438,13.5 L127.60781,13.5 C131.04584,13.5 134,11.175 134,7.3 C134,2.975 131.04584,1 127.60781,1 L119,1 L119,18 Z M126.920204,4.65 C128.42275,4.65 129.568761,5.625 129.568761,7.275 C129.568761,8.825 128.42275,9.85 126.920204,9.85 L123.278438,9.85 L123.278438,4.65 L126.920204,4.65 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "151 18 151 14.35 141.102564 14.35 141.102564 11.1 149.128205 11.1 149.128205 7.575 141.102564 7.575 141.102564 4.65 151 4.65 151 1 137 1 137 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,18 L157.261838,18 L158.440111,14.875 L165.584958,14.875 L166.738162,18 L171,18 L164.532033,1 L159.593315,1 L153,18 Z M162.075209,5.15 L164.532033,11.8 L159.493036,11.8 L162.075209,5.15 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropea);
export default __webpack_public_path__ + "static/media/europea.f21ee9fad12103fb86df2460f288bff5.svg";
export { ForwardRef as ReactComponent };